export default __webpack_public_path__ + "static/media/temu.d5082e22.svg";